var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM8.5332 11.4498C8.5332 11.4498 14.9729 15.1016 16.2228 15.1016C17.5329 15.1016 23.9028 11.5196 23.9028 11.5196L23.913 10.8796C23.913 10.173 23.3396 9.59961 22.6311 9.59961H9.81448C9.10664 9.59961 8.5332 10.173 8.5332 10.8796V11.4498ZM23.9028 13.44C23.9028 13.44 17.593 16.862 16.2228 16.862C14.9729 16.862 8.5428 13.44 8.54344 13.44L8.5332 21.12C8.5332 21.8266 9.10728 22.4 9.81448 22.4H22.6311C23.3396 22.4 23.913 21.8266 23.913 21.12L23.9028 13.44Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailColored);
export default __webpack_public_path__ + "static/media/mail-colored.8ab052b7b1c3a47c410cca05d238fff5.svg";
export { ForwardRef as ReactComponent };